export const SPOOF_SIGTYPE = '03'
